import { api } from './authService'

// Cart service
const cartService = {
  // Calculate cart price with all discounts
  calculateCartPrice: (cartData) => {
    return api.post('/api/cart/calculate', cartData).then(r => r.data)
  },

  // Check product price and availability
  checkPrice: (data) => {
    return api.post('/api/products/price-check', data).then(r => r.data)
  },

  // Validate promotion code
  validatePromotionCode: (data) => {
    return api.post('/api/promotions/validate', data).then(r => r.data)
  },

  // Get volume discounts for product
  getVolumeDiscounts: (productId, quantity) => {
    return api.get(`/api/products/${productId}/volume-discounts`, {
      params: { quantity },
    }).then(r => r.data)
  },

  // B2B: Quick order by SKU
  quickOrderBySKU: (skuList) => {
    return api.post('/api/cart/quick-order', { skuList }).then(r => r.data)
  },

  // B2B: Get saved lists
  getSavedLists: () => {
    return api.get('/api/cart/saved-lists').then(r => r.data)
  },

  // B2B: Save current cart as list
  saveCartAsList: (listName) => {
    return api.post('/api/cart/save-list', { name: listName }).then(r => r.data)
  },

  // B2B: Load saved list to cart
  loadSavedList: (listId) => {
    return api.post(`/api/cart/load-list/${listId}`).then(r => r.data)
  },

  // B2B: Request quote for cart
  requestQuote: (cartData) => {
    return api.post('/api/cart/request-quote', cartData).then(r => r.data)
  },
}

export default cartService